import React, { useContext, Fragment } from "react";
import PropTypes from "prop-types";

import { EligibilityContext } from "../../contexts/EligibilityContext";
import DiseaseFundOpenCard from "./DiseaseFundOpenCard";
import DiseaseFundClosedCard from "./DiseaseFundClosedCard";
import DiseaseFundWaitListOnlyCard from "./DiseaseFundWaitListOnlyCard";
import { fundStatusColor, fundStatusLabel } from "../../helpers/fund";

import { notDiseaseFund } from "../../helpers/fund";

const DiseaseFundBanner = ({ title, data, jumpLink, grantType, assistanceAmount }) => {
  const status = data.Fund_Status.toLowerCase();

  return (
    <Fragment>
      <div className="Page-banner hasCard">
        <div className="Page-banner-titleContainer">
          <a href="/disease-funds/">
            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.325 13L13.925 18.6L12.5 20L4.5 12L12.5 4L13.925 5.4L8.325 11H20.5V13H8.325Z" fill="white"/>
            </svg>
            Back to disease funds
          </a>
          <span className={`StatusTag u-mb1 StatusTag--${fundStatusColor(data, true)}`}>
            {fundStatusLabel(data)}
          </span>

          <h1 className="Page-banner-pageTitle f-pageTitle-sans u-mb1">
            {title}
          </h1>

          <p className="f-pageSubtitle c-white f-light disease-fund-grant-type">
            {grantType}
          </p>

          <p className="f-pageSubtitle c-white f-light disease-fund-assistance-amount">
            {assistanceAmount}
          </p>
        </div>
      </div>
    </Fragment>
  );
};

DiseaseFundBanner.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
};

export default DiseaseFundBanner;
